import {
  atualizaEtapasTunnel,
  configuraTunnel,
  createTunnelToken,
  deleteTunnel,
  refreshTunnel,
  validateConnector
} from 'src/integracoes/servicos/mongo-atlas/funcoes/cloudFlare';
import {
  UPDATE_ETAPAS_TUNNEL_INIT,
  CONFIGURE_ROTA_TUNNEL_INIT,
  CREATE_TUNNEL_NAME_INIT,
  REFRESH_TUNNEL_INIT,
  VALIDATE_CONNECTOR_INIT,
  DELETE_TUNNEL_INIT
} from '../actionTypes';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  updateEtapasTunnelSuccess,
  configureRotaTunnelSuccess,
  createNameTunelSuccess,
  errorCloudFlareTunelMsg,
  refreshTunelSuccess,
  validateConnectorSuccess,
  deleteTunnelSuccess
} from '../actions';
import { portalName } from 'src/config';
import { IEtapasTunnel } from 'src/integracoes/servicos/mongo-atlas/modelos/IParametrosIntegracao';

const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[()]/g, '')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

// ------------------- Criar Tunnel e Gerar Token -----------------------------
const fetchCreateTunnelToken = async (payload: any) => {
  try {
    const { status, dados, mensagem } = await createTunnelToken(payload);

    if (status) {
      return {
        isError: false,
        tunnelToken: dados.tunnelToken,
        msg: mensagem
      };
    }

    return {
      isError: true,
      tunnelToken: null,
      msg: mensagem
    };
  } catch (error: any) {
    const msg = error?.causa?.mensagem || error?.mensagem || 'Erro inesperado ao criar túnel';

    return {
      isError: true,
      tunnelToken: null,
      msg,
      codigo: error?.causa?.codigo || 'UNKNOWN_ERROR'
    };
  }
};

export function* paraseCreateTunnelToken({ payload }: { payload: any; type: any }) {
  try {
    const { empData } = payload;
    const identificador = String(empData.identificador ?? '');

    const tunnelName = `${portalName}-${normalize(identificador)}`;

    const { isError, msg } = yield call(fetchCreateTunnelToken, {
      empId: empData.id,
      name: tunnelName
    });

    if (!isError) {
      yield put(createNameTunelSuccess({ msg }));
    } else {
      yield put(errorCloudFlareTunelMsg({ msg, isError }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorCloudFlareTunelMsg({ msg: mensagem }));
  }
}

export function* watchCreateTunnelToken() {
  yield takeEvery(CREATE_TUNNEL_NAME_INIT, paraseCreateTunnelToken);
}

// ------------------- Refresh Tunnel Token -----------------------------
export const refreshTunnelToken = async (tunnel: {
  empId: string;
  tunnelId: string;
  tunnelName: string;
}) => {
  try {
    const { status, dados, mensagem } = await refreshTunnel(tunnel.tunnelId, {
      empId: tunnel.empId,
      tunnelName: tunnel.tunnelName
    });

    if (status) {
      return {
        isError: false,
        tunnelCommand: dados.tunnelCommand,
        msg: mensagem
      };
    }

    return {
      isError: true,
      tunnelCommand: null,
      msg: mensagem
    };
  } catch (error: any) {
    const msg = error?.causa?.mensagem || error?.mensagem || 'Erro inesperado ao resetar túnel';

    return {
      isError: true,
      tunnelCommand: null,
      msg,
      codigo: error?.causa?.codigo || 'UNKNOWN_ERROR'
    };
  }
};

export function* parseRefreshTunnelToken({ payload }: { payload: any; type: any }) {
  try {
    const { tunnelData } = payload;

    const { isError, msg } = yield call(refreshTunnelToken, tunnelData);

    if (!isError) {
      yield put(refreshTunelSuccess({ msg }));
    } else {
      yield put(errorCloudFlareTunelMsg({ msg, isError }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorCloudFlareTunelMsg({ msg: mensagem }));
  }
}

export function* watchRefreshTunnelToken() {
  yield takeEvery(REFRESH_TUNNEL_INIT, parseRefreshTunnelToken);
}

// ------------------- Validate Connector -----------------------------
export const validateConnectorTunnel = async (tunnelId: string, connectorId: string) => {
  try {
    const { status, mensagem, dados } = await validateConnector(tunnelId, connectorId);

    if (status) {
      return {
        isError: false,
        connected: dados.connected,
        msg: mensagem
      };
    }

    return {
      isError: true,
      connected: dados.connected,
      msg: mensagem
    };
  } catch (error: any) {
    const msg = error?.causa?.mensagem || error?.mensagem || 'Erro inesperado ao resetar túnel';

    return {
      isError: true,
      msg,
      codigo: error?.causa?.codigo || 'UNKNOWN_ERROR'
    };
  }
};

export function* parseValidateConnector({ payload }: { payload: any; type: any }) {
  try {
    const { tunnelId, connectorId } = payload;

    const { isError, msg, connected } = yield call(validateConnectorTunnel, tunnelId, connectorId);

    if (!isError) {
      yield put(validateConnectorSuccess({ msg, connected }));
    } else {
      yield put(errorCloudFlareTunelMsg({ msg, isError }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorCloudFlareTunelMsg({ msg: mensagem }));
  }
}

export function* watchValidateConnector() {
  yield takeEvery(VALIDATE_CONNECTOR_INIT, parseValidateConnector);
}

// ------------------- Configure Tunnel Service (Rota) -----------------------------
export const configureTunnelService = async (
  tunnelId: string,
  host: string,
  porta: number,
  tunnelName: string
) => {
  try {
    const { status, mensagem, dados } = await configuraTunnel(tunnelId, host, porta, tunnelName);

    if (status) {
      return {
        isError: false,
        tunnelExist: dados.tunnelExist,
        msg: mensagem
      };
    }

    return {
      isError: true,
      tunnelExist: dados.tunnelExist,
      msg: mensagem
    };
  } catch (error: any) {
    const msg = error?.causa?.mensagem || error?.mensagem || 'Erro inesperado ao resetar túnel';

    return {
      isError: true,
      msg,
      codigo: error?.causa?.codigo || 'UNKNOWN_ERROR'
    };
  }
};

export function* parseConfigureTunnelService({ payload }: { payload: any; type: any }) {
  try {
    const { tunnelId, host, porta, tunnelName } = payload;

    const { isError, msg, tunnelExist } = yield call(
      configureTunnelService,
      tunnelId,
      host,
      porta,
      tunnelName
    );

    if (!isError) {
      yield put(configureRotaTunnelSuccess({ msg, tunnelExist }));
    } else {
      yield put(errorCloudFlareTunelMsg({ msg, isError }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorCloudFlareTunelMsg({ msg: mensagem }));
  }
}

export function* watchConfigureTunnelService() {
  yield takeEvery(CONFIGURE_ROTA_TUNNEL_INIT, parseConfigureTunnelService);
}

// ------------------- Update Etapas CloudFlare -----------------------------
export const updateEtapasTunnel = async (tunnelId: string, etapas: IEtapasTunnel) => {
  try {
    const { status, mensagem } = await atualizaEtapasTunnel(tunnelId, etapas);

    return {
      isError: !status,
      msg: mensagem
    };
  } catch (error: any) {
    const msg =
      error?.causa?.mensagem || error?.mensagem || 'Erro inesperado ao salvar etapas do túnel';

    return {
      isError: true,
      msg,
      codigo: error?.causa?.codigo || 'UNKNOWN_ERROR'
    };
  }
};

export function* parseUpdateEtapasTunnel({ payload }: { payload: any; type: any }) {
  try {
    const { tunnelId, etapas } = payload;

    const { isError, msg } = yield call(updateEtapasTunnel, tunnelId, etapas);

    if (!isError) {
      yield put(updateEtapasTunnelSuccess());
    } else {
      yield put(errorCloudFlareTunelMsg({ msg, isError }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorCloudFlareTunelMsg({ msg: mensagem }));
  }
}

export function* watchUpdateEtapasTunnel() {
  yield takeEvery(UPDATE_ETAPAS_TUNNEL_INIT, parseUpdateEtapasTunnel);
}

// ------------------- Delete Tunnel CloudFlare -----------------------------
export const fetchDeleteTunnel = async (tunnelId: string, empId: string, tunnelName: string) => {
  try {
    const { status, mensagem } = await deleteTunnel(tunnelId, empId, tunnelName);

    return {
      isError: !status,
      msg: mensagem
    };
  } catch (error: any) {
    const msg = error?.causa?.mensagem || error?.mensagem || 'Erro inesperado ao deletar túnel';

    return {
      isError: true,
      msg,
      codigo: error?.causa?.codigo || 'UNKNOWN_ERROR'
    };
  }
};

export function* parseDeleteTunnel({ payload }: { payload: any; type: any }) {
  try {
    const { tunnelId, empId, tunnelName } = payload;

    const { isError, msg } = yield call(fetchDeleteTunnel, tunnelId, empId, tunnelName);

    if (!isError) {
      yield put(deleteTunnelSuccess({ msg }));
    } else {
      yield put(errorCloudFlareTunelMsg({ msg, isError }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorCloudFlareTunelMsg({ msg: mensagem }));
  }
}

export function* watchDeleteTunnel() {
  yield takeEvery(DELETE_TUNNEL_INIT, parseDeleteTunnel);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchCreateTunnelToken),
    fork(watchRefreshTunnelToken),
    fork(watchValidateConnector),
    fork(watchConfigureTunnelService),
    fork(watchUpdateEtapasTunnel),
    fork(watchDeleteTunnel)
  ]);
}
